module.exports = __webpack_public_path__ + "static/media/Ksenia_Simakova.41d38644.jpg";